<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Withdrawal of partners')"
          :description="$t('From here you can control partner withdrawals')"
        />
        <indexTable
          :searchText="$t('Search for an operation')"
          :emptyTableText="$t('There are no withdrawals operations')"
          :buttonRole="$checkRole('partners_withdrawals_add')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Draft'), value: 0 },
            { title: $t('Approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('Process'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'partner_id',
              title: $t('Partner name'),
              type: 'link',
              to: 'partner',
              sort: true,
              link: true
            },
            {
              column: 'safe_id',
              title: $t('Treasury'),
              type: 'link',
              to: 'safe',
              sort: true,
              link: true
            },
            { column: 'date', title: $t('Date'), type: 'text', sort: true },
            {
              column: 'description',
              title: $t('And that is about'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('Cost'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true,
              icon: 'usd-square'
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Draft'), value: 0, color: 'dark' },
                { title: $t('Approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('Actions'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('partners_withdrawals_edit')
                },
                { name: 'file' },
                { name: 'printPurchasePayment', role: true },
                { name: 'download', role: true },
                {
                  name: 'delete',
                  role: $checkRole('partners_withdrawals_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/partnersWithdrawals'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
